
class HXFormFieldNumber extends HXFormField {

    constructor(inputName,formName) {
        super(inputName,formName);
    }

    /**
     * @param {boolean} alertResult true gibt eine alert-meldung aus, false: validationMsg und validationPassed werden befuellt
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();

        if (this.fieldExists()===true && this.getEditable() === true) {
            this.setValue(this.getValue()); //setValue() -> Aufformatieren inkl. Spaces aus Feld entfernen
            this.inputObj.value = replace(this.getValue(),'.',''); //Punkte aus Feld entfernen - ohne setValue() - sonst wird autom. wieder eingefuegt
            var value = ''+this.getValue();

            if (value === '') {
                if (this.getOptional()==false){
                    this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());
                    this.validationPassed = false;
                }
            } else {
                var decimalplaces        = hx.cint(this.getDecimalplaces());
                var formatMsgText        = hx.replace(this.formVars.dictFormatMsg, "#name#", this.getLabel());
                var limitMsgText         = hx.replace(this.formVars.dictLimitMsg, "#name#", this.getLabel());
                    limitMsgText         = hx.replace(limitMsgText, "#limits#", hx.formatPreis(this.getRangeMin(),decimalplaces) +
                                                                                 " ... " + hx.formatPreis(this.getRangeMax(),decimalplaces));
                var valueNbr = hx.text2float(value);

                if (valueNbr === null) {  // keine gueltige Zahl
                    this.validationPassed = false;
                    this.validationMsg = formatMsgText;

                } else if (valueNbr < this.getRangeMin() || valueNbr > this.getRangeMax()) {
                    this.validationPassed = false;
                    this.validationMsg = limitMsgText;
                }
            }
            if (alertResult===true) super._validateFieldAlert();
        }
        return this.validationPassed;
    }


    /**
     * @param {string} value formatierte Zahl mit ',' als Dezimaltrennzeichen und '.' aus Tausendertrenner
     */
    setValue(value) {
        super.setValue(this.getReformated(value));
    }

    /**
     * @return {float|int} rangeMin
     */
    getRangeMin() {
        return hx.cfloat(this.inputObj.getAttribute('data-hx-rangemin'));
    }

    /**
     * @param {float|int} minValue (null nicht zulaessig, range ist zwingend anzugeben)
     */
    setRangeMin(minValue) {
        this.inputObj.setAttribute('data-hx-rangemin',hx.cfloat(minValue));
    }

    /**
     * @return {float|int} rangeMax
     */
    getRangeMax() {
        return hx.cfloat(this.inputObj.getAttribute('data-hx-rangemax'));
    }

    /**
     * @param {float|int} maxValue (null nicht zulaessig, range ist zwingend anzugeben)
     */
    setRangeMax(maxValue) {
        this.inputObj.setAttribute('data-hx-rangemax',hx.cfloat(maxValue));
    }

    /**
     * @return {int}
     */
    getDecimalplaces() {
        return hx.cint(this.inputObj.getAttribute('data-hx-decimalplaces'));
    }

    /**
     * @param {int} numberOfPlaces, -1: so viele wie noetig
     */
    setDecimalplaces(numberOfPlaces) {
        this.inputObj.setAttribute('data-hx-decimalplaces',hx.cint(numberOfPlaces));
    }

    /**
     * @return {boolean}
     */
    getThousandSeparator() {
        return this.inputObj.getAttribute('data-hx-thousandseparator') === 'true';
    }

    /**
     * @param {boolean} display, true: anzeigen (1.234,12), false: nicht anzeigen (1234,12)
     */
    setThousandSeparator(display) {
        this.inputObj.setAttribute("data-hx-thousandseparator", Boolean(display));
    }

    /**
     * @return {float} interval
     */
    getInterval() {
        return hx.cfloat(this.inputObj.getAttribute('data-hx-interval'));
    }

    /**
     * @param {float} value
     */
    setInterval(value) {
        this.inputObj.setAttribute('data-hx-interval',hx.cfloat(value));
    }

    /**
     * @param {boolean} optional
     */
    setOptional(optional) {
        super.setOptional(optional,'number');
    }

    /**
     * rounds value to inverval if set
     * @param {float|int} value
     * @returns {float|int} value gemaess interval
     */
    getRoundedToInterval(value){
        var decimalPlaces = this.getDecimalplaces();
        var interval = this.getInterval();

        if (interval==0) return value;

        return Math.round(value / interval) * interval;
    }

    /**
     * Reformates the value to the current settings of the field
     * removes spaces, checks if valid int/float, round to interval, set decimalplaces, set thousandSeparator
     * @param {string} value
     * @return {string} newValue
     */
    getReformated(value) {
        value = (''+value).replace(/ /g, ''); //regex: alle Spaces entfernen
        value = hx.text2float(value); //in float umwandeln, ist null wenn ungueltig, e-hoch Zahl wird umgewandelt
        if (value!=null && value.toString().indexOf('e')>=0) value=null;
        if (value != null) {
            if (this.getInterval() > 0.0) value = this.getRoundedToInterval(value);
            value = hx.formatPreis(value, this.getDecimalplaces());
            if (!this.getThousandSeparator()) value = hx.replace(value, '.', '');
        }
        return value;
    }

    /**
     * Events einhaengen
     */
    displayInit() {
        if (this.fieldExists()===true && this.getEditable()) {
            this.inputObj.addEventListener("keydown", (event) => { //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                var keyPressed = event.key;
                var value = hx.text2float(this.getValue());

                //Up Down Tasten aktuellen Wert erhoehen oder erniedrigen (um  +/-1 oder +/-Intervall)
                if (value != null) {
                    var add = 1;
                    if (this.getInterval()>0) add=this.getInterval();
                    if (!event.ctrlKey){
                        if(keyPressed === "ArrowUp" && (value + add) <= this.getRangeMax()) this.setValue(hx.formatPreis(hx.round(value + add, 10), -1));
                        if(keyPressed === "ArrowDown" && (value - add) >= this.getRangeMin()) this.setValue(hx.formatPreis(hx.round(value - add, 10), -1));
                    }
                }
                //Eingabezeichen zulassen (schliesst auch das Numpad mit ein)
                if (hx.value_in(keyPressed, "+", "-", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ",", "e", ".")) {
                    return true;
                }
                //Steuertasten zulassen (schliesst auch das Numpad mit ein)
                if (hx.value_in(keyPressed, "Tab", "Backspace", "Delete", "Enter", "End", "Home", "ArrowLeft", "ArrowRight")) {
                    return true;
                }
                //Tastenkombinationen Windows/Mac zulassen  Ctrl/Cmd -C , Ctrl/Cmd -V, Ctrl/Cmd -A, Ctrl/Cmd -X
                if ((event.ctrlKey || event.metaKey) && hx.value_in(keyPressed, "c", "v", "a", "x")) {
                    return true;
                }

                event.preventDefault(); //Erscheinen ungueltiger Zeichen im Feld verhindern
                return false;
            });

            this.inputObj.addEventListener("blur", (event) => { //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                this.setValue(this.getValue());
            });

        }
    }

}
